import { useEffect, useState } from "react"

import { useDispatch, useSelector } from "react-redux"

import {
  getAdminDescriptorsByEnrollment,
  getMoreAdminDescriptorsByEnrollment
} from "../../../User/redux/user.thunks"

const FETCH_DEBOUNCE = 300

const useFetchAdminDescriptorsList = ({
  enrollmentId,
  filters,
  PAGE_SIZE,
  statusesReady,
  userEnrollmentsFetching
}) => {
  const dispatch = useDispatch()
  const {
    adminDescriptorsByEnrollment,
    adminDescriptorsByEnrollmentFetching,
    moreAdminDescriptorsByEnrollmentFetching
  } = useSelector((state) => state.user)
  const [page, setPage] = useState(1)
  const [fetchScheduled, setFetchScheduled] = useState(false)
  const hasMore = adminDescriptorsByEnrollment?.count > page * PAGE_SIZE
  const moreLoading = moreAdminDescriptorsByEnrollmentFetching
  const loading =
    adminDescriptorsByEnrollmentFetching ||
    fetchScheduled ||
    !statusesReady ||
    userEnrollmentsFetching
  const descriptors = adminDescriptorsByEnrollment?.results || []

  const buildParams = (nextPage) => ({
    enrollment_id: enrollmentId,
    descriptor: filters?.search || null,
    status: filters?.statuses?.join(",") || null,
    page: nextPage,
    page_size: PAGE_SIZE
  })

  const fetchMore = () => {
    if (!enrollmentId || !hasMore || moreLoading) {
      return
    }
    dispatch(getMoreAdminDescriptorsByEnrollment(buildParams(page + 1)))
    setPage((prevPage) => prevPage + 1)
  }

  // Single entry point for the first page: waits for the available statuses so the request
  // always carries the filter the dropdown shows, and debounces so an enrollment switch or
  // a search keystroke fires one request instead of several racing ones.
  useEffect(() => {
    if (!enrollmentId || userEnrollmentsFetching || !statusesReady) {
      setFetchScheduled(false)
      return
    }
    setFetchScheduled(true)
    const timeout = setTimeout(() => {
      setFetchScheduled(false)
      dispatch(getAdminDescriptorsByEnrollment(buildParams(1)))
      setPage(1)
    }, FETCH_DEBOUNCE)
    return () => clearTimeout(timeout)
  }, [enrollmentId, userEnrollmentsFetching, statusesReady, filters])

  return { descriptors, fetchMore, hasMore, loading, moreLoading }
}

export default useFetchAdminDescriptorsList
